import { cva } from 'class-variance-authority';

export const backToTopRootVariants = cva('fixed bottom-6 right-6 z-50');

export const backToTopButtonVariants = cva('size-11 shadow-[0_4px_6px_rgba(0,0,0,0.18)]');
